// extracted by mini-css-extract-plugin
module.exports = {"component":"ButtonLink_component__rWP_F","icon":"ButtonLink_icon__meE5B"};